import { getCoreBlocks } from './core.js';

const blockSeparator = '<sep gap="36"/>'; // At default scale, about 28px
const gap = '<sep gap="36"/>';

const ev3MovementToolbox = function () {
    return `
  <category
      name="Movement"
      id="ev3_movement"
      colour="#F65DCE"
      secondaryColour="#E20F9C">
      <block type="ev3_movement_moveDirectionForUnits">
          <value name="RATE">
              <shadow type="math_number">
                  <field name="NUM">1</field>
              </shadow>
          </value>
      </block>
      <block type="ev3_movement_moveHeadingForUnits">
          <value name="HEADING">
              <shadow type="ev3_heading_input">
                  <field name="NUM">straight: 0</field>
              </shadow>
          </value>
          <value name="RATE">
              <shadow type="math_number">
                  <field name="NUM">1</field>
              </shadow>
          </value>
      </block>
      ${blockSeparator}
      <block type="ev3_movement_startMoving">
          <value name="HEADING">
              <shadow type="ev3_heading_input">
                  <field name="NUM">straight: 0</field>
              </shadow>
          </value>
      </block>
      <block type="ev3_movement_stopMoving">
      </block>
      ${blockSeparator}
      <block type="ev3_movement_setMovementSpeed">
          <value name="SPEED">
              <shadow type="math_number">
                  <field name="NUM">50</field>
              </shadow>
          </value>
      </block>
      ${blockSeparator}]
      <block type="ev3_movement_moveHeadingForUnitAtSpeed">
          <value name="HEADING">
              <shadow type="ev3_heading_input">
                  <field name="NUM">straight: 0</field>
              </shadow>
          </value>
          <value name="RATE">
              <shadow type="math_number">
                  <field name="NUM">1</field>
              </shadow>
          </value>
          <value name="SPEED">
              <shadow type="math_number">
                  <field name="NUM">50</field>
              </shadow>
          </value>
      </block>
      <block type="ev3_movement_moveForUnitsAtSpeeds">
          <value name="RATE">
              <shadow type="math_number">
                  <field name="NUM">1</field>
              </shadow>
          </value>
          <value name="LSPEED">
              <shadow type="math_number">
                  <field name="NUM">50</field>
              </shadow>
          </value>
          <value name="RSPEED">
              <shadow type="math_number">
                  <field name="NUM">50</field>
              </shadow>
          </value>
      </block>
      ${blockSeparator}
      <block type="ev3_movement_startMovingHeadingAtSpeed">
          <value name="HEADING">
              <shadow type="ev3_heading_input">
                  <field name="NUM">straight: 0</field>
              </shadow>
          </value>
          <value name="SPEED">
              <shadow type="math_number">
                  <field name="NUM">50</field>
              </shadow>
          </value>
      </block>
      <block type="ev3_movement_startMovingAtSpeeds">
          <value name="LSPEED">
              <shadow type="math_number">
                  <field name="NUM">50</field>
              </shadow>
          </value>
          <value name="RSPEED">
              <shadow type="math_number">
                  <field name="NUM">50</field>
              </shadow>
          </value>
      </block>
  </category>
  `;
};

const ev3MotorToolbox = function () {
    return `
    <category
        name="Motors"
        id="ev3_motor"
        colour="#088FF1"
        secondaryColour="#0678C8">
        <block type="ev3_motor_runForDirectionTimes">
            <value name="MOTOR"><shadow type="ev3_sensor_motor_menu"></shadow></value>
            <value name="RATE">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="ev3_motor_runDirection">
        <value name="MOTOR"><shadow type="ev3_sensor_motor_menu"></shadow></value>
        </block>
        <block type="ev3_motor_stopMotor">
        <value name="MOTOR"><shadow type="ev3_sensor_motor_menu"></shadow></value>
        </block>
        ${blockSeparator}
        <block type="ev3_motor_setSpeedTo">
        <value name="MOTOR"><shadow type="ev3_sensor_motor_menu"></shadow></value>
            <value name="SPEED">
                <shadow type="math_number">
                    <field name="NUM">75</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="ev3_motor_motorRunForTimesAtSpeed">
        <value name="MOTOR"><shadow type="ev3_sensor_motor_menu"></shadow></value>
            <value name="RATE">
                <shadow type="math_number">
                    <field name="NUM">5</field>
                </shadow>
            </value>
            <value name="SPEED">
                <shadow type="math_number">
                    <field name="NUM">75</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="ev3_motor_motorStartMotorAtSpeed">
        <value name="MOTOR"><shadow type="ev3_sensor_motor_menu"></shadow></value>
            <value name="SPEED">
                <shadow type="math_number">
                    <field name="NUM">75</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="ev3_motor_resetDegreesCounted">
        <value name="MOTOR"><shadow type="ev3_sensor_motor_menu"></shadow></value>
        </block>
        <block type="ev3_motor_degreesCounted">
        <value name="MOTOR"><shadow type="ev3_sensor_motor_menu"></shadow></value>
        </block>
    </category>
    `;
};

const ev3SensorsToolbox = function () {
    return `
    <category
        name="Sensors"
        id="ev3_sensors"
        colour="#3ecbf0"
        secondaryColour="#2cb5da">
        <block type="ev3_sensor_waitUntilColorSensor">
            <value name="PORT">
              <shadow type="ev3_sensor_port_menu"><field name="PORT">3</field></shadow>
            </value>
            <value name="COLOR">
              <shadow type="ev3_sensor_color_menu"><field name="COLOR">red</field></shadow>
            </value>
        </block>
        <block type="ev3_sensor_reflected_light_intensity">
            <value name="PORT">
                <shadow type="ev3_sensor_port_menu"><field name="PORT">3</field></shadow>
            </value>
        </block>
        <block type="ev3_sensor_is_color">
            <value name="PORT">
                <shadow type="ev3_sensor_port_menu"><field name="PORT">3</field></shadow>
            </value>
            <value name="COLOR">
              <shadow type="ev3_sensor_colorUnchanged_menu"><field name="COLOR">red</field></shadow>
            </value>
        </block>
        <block type="ev3_sensor_color">
            <value name="PORT">
              <shadow type="ev3_sensor_port_menu"><field name="PORT">3</field></shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="ev3_sensor_waitUntilTouchSensor">
            <value name="PORT">
                <shadow type="ev3_sensor_port_menu"><field name="PORT">1</field></shadow>
            </value>
        </block>
        <block type="ev3_sensor_is_pressed">
            <value name="PORT">
                <shadow type="ev3_sensor_port_menu"><field name="PORT">1</field></shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="ev3_sensor_waitUntilDistanceSensor">
            <value name="PORT">
                <shadow type="ev3_sensor_port_menu"><field name="PORT">4</field></shadow>
            </value>
            <value name="DISTANCE">
                <shadow type="math_number">
                    <field name="NUM">15</field>
                </shadow>
            </value>
        </block>
        <block type="ev3_sensor_is_distance">
            <value name="PORT">
                <shadow type="ev3_sensor_port_menu"><field name="PORT">4</field></shadow>
            </value>
            <value name="DISTANCE">
                <shadow type="math_number">
                    <field name="NUM">45</field>
                </shadow>
            </value>
        </block>
        <block type="ev3_sensor_distance">
            <value name="PORT">
            <shadow type="ev3_sensor_port_menu"><field name="PORT">4</field></shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="ev3_sensor_waitUntilGyroSensor">
            <value name="PORT">
                <shadow type="ev3_sensor_port_menu"><field name="PORT">2</field></shadow>
            </value>
            <value name="ANGLE">
                <shadow type="math_number">
                    <field name="NUM">45</field>
                </shadow>
            </value>
        </block>
        <block type="ev3_sensor_is_angle">
            <value name="PORT"><shadow type="ev3_sensor_port_menu"><field name="PORT">2</field></shadow></value>
            <value name="ANGLE">
                <shadow type="math_number">
                    <field name="NUM">45</field>
                </shadow>
            </value>
        </block>
        <block type="ev3_sensor_angle">
        <value name="PORT"><shadow type="ev3_sensor_port_menu"><field name="PORT">2</field></shadow></value>
        </block>
        <block type="ev3_sensor_reset_angle">
        <value name="PORT"><shadow type="ev3_sensor_port_menu"><field name="PORT">2</field></shadow></value>
        </block>
        <block type="ev3_sensor_anglular_velocity">
        <value name="PORT"><shadow type="ev3_sensor_port_menu"><field name="PORT">2</field></shadow></value>
        </block>
    </category>
    `;
};

const ev3SoundToolbox = function () {
    return `
    <category
        name="Sound"
        id="ev3_sound"
        colour="#b473e0"
        secondaryColour="#963fd1">
        <block type="ev3_sound_playuntildone">
        </block>
        <block type="ev3_sound_startsound">
        </block>
        <block type="ev3_play_beep">
            <value name="TONE">
                <shadow type="ev3_tone_input">
                    <field name="NUM">60</field>
                </shadow>
            </value>
            <value name="DURATION">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="ev3_start_playing_beep">
            <value name="TONE">
                <shadow type="ev3_tone_input">
                    <field name="NUM">60</field>
                </shadow>
            </value>
        </block>
        <block type="ev3_stop_all_sounds">
        </block>
        <block type="ev3_set_volume">
            <value name="VOLUME">
                <shadow type="ev3_percent_input">
                    <field name="NUM">100</field>
                </shadow>
            </value>
        </block>
    </category>
    `;
};

const makeEV3ToolboxXML = () => {
    const xmlOpen = '<xml style="display: none">';
    const xmlClose = "</xml>";
    const coreCategories = getCoreBlocks();
    return [
        xmlOpen,
        gap,
        ev3MovementToolbox(),
        gap,
        ev3SensorsToolbox(),
        gap,
        ev3SoundToolbox(),
        gap,
        coreCategories,
        xmlClose
    ].join("\n");



}
export {makeEV3ToolboxXML, ev3SensorsToolbox, ev3MovementToolbox, ev3SoundToolbox, ev3MotorToolbox};
